import { useEffect, useState } from 'react'

export function usePageFreezeStatus(onFreeze: () => void, onResume: () => void) {
  const [isFrozen, setIsFrozen] = useState(false)

  // Callback refs to execute code before freezing and upon resuming
  const freezeHandler = () => {
    console.debug('freeze')
    setIsFrozen(true)
    if (onFreeze) onFreeze()
  }

  const resumeHandler = () => {
    console.debug('resume')
    setIsFrozen(false)
    if (onResume) onResume()
  }

  useEffect(() => {
    document.addEventListener('freeze', freezeHandler)
    document.addEventListener('resume', resumeHandler)

    return () => {
      document.removeEventListener('freeze', freezeHandler)
      document.removeEventListener('resume', resumeHandler)
    }
  }, [onFreeze, onResume])

  return isFrozen
}
